<!--
 * @Author: kim
 * @Date: 2021-07-15 10:25:05
 * @LastEditTime: 2021-10-13 11:37:52
 * @Description: 封面
 * @FilePath: /yiqijian_video/template/web/pc/yiqijian-video/components/banner.vue
-->
<template>
  <div class="banner">
    <div :class="['banner-cover', type]">
      <video class="banner-player" loop autoplay muted v-if="type === 'video'">
        <source
          :src="url"
          type="video/mp4"
        />
      </video>
      <img class="banner-player" :src="url" alt="" v-else>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    height: {
      type: Number | String,
      default: 560
    },
    // banner 类型
    type: {
      type: String,
      default: 'image'
    },
    // 链接
    url: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="less">
@input-height: 60px;

.banner {
  position: relative;
  margin: auto;
  width: 100%;
  min-width: 1216px;
  height: 560px;

  .banner-cover {
    overflow: hidden;
    position: relative;
    // left: 0;
    // top: 0;
    display: block;
    width: 100%;
    min-width: 1216px;
    height: 100%;
    object-fit: cover;
    object-position: center;

    &.video {
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
      }
    }
    
    .banner-player {
      display: block;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?97109f94